import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
var LOCALES = [{
  market: 'FR',
  currency: 'EUR',
  symbol: '€',
  language: 'fr',
  iso: 'fr-FR',
  name: 'Français'
}, {
  market: 'BE',
  currency: 'EUR',
  symbol: '€',
  language: 'nl',
  iso: 'nl-BE',
  name: 'België (Nederlands)'
}, {
  market: 'BE',
  currency: 'EUR',
  symbol: '€',
  language: 'fr',
  iso: 'fr-BE',
  name: 'Belgique (Français)'
}, {
  market: 'DE',
  currency: 'EUR',
  symbol: '€',
  language: 'de',
  iso: 'de-DE',
  name: 'Deutschland'
}, {
  market: 'ES',
  currency: 'EUR',
  symbol: '€',
  language: 'es',
  iso: 'es-ES',
  name: 'España'
}, {
  market: 'IT',
  currency: 'EUR',
  symbol: '€',
  language: 'it',
  iso: 'it-IT',
  name: 'Italia'
}, {
  market: 'LU',
  currency: 'EUR',
  symbol: '€',
  language: 'fr',
  iso: 'fr-LU',
  name: 'Luxembourg'
}, {
  market: 'NL',
  currency: 'EUR',
  symbol: '€',
  language: 'nl',
  iso: 'nl-NL',
  name: 'Nederland'
}, {
  market: 'AT',
  currency: 'EUR',
  symbol: '€',
  language: 'de',
  iso: 'de-AT',
  name: 'Österreich'
}, {
  market: 'PT',
  currency: 'EUR',
  symbol: '€',
  language: 'pt',
  iso: 'pt-PT',
  name: 'Portugal'
}, {
  market: 'CH',
  currency: 'CHF',
  symbol: 'CHF',
  language: 'de',
  iso: 'de-CH',
  name: 'Schweiz (Deutsch)'
}, {
  market: 'CH',
  currency: 'CHF',
  symbol: 'CHF',
  language: 'it',
  iso: 'it-CH',
  name: 'Svizzera (Italiano)'
}, {
  market: 'CH',
  currency: 'CHF',
  symbol: 'CHF',
  language: 'fr',
  iso: 'fr-CH',
  name: 'Suisse (Français)'
}, {
  market: 'UK',
  currency: 'GBP',
  symbol: '£',
  language: 'en',
  iso: 'en-GB',
  name: 'United Kingdom'
}];
var SERVICE_NUMBER = [{
  number: '0805 98 12 84',
  market: 'FR',
  language: 'fr'
}, {
  number: '080 07 59 63',
  market: 'BE',
  language: 'nl'
}, {
  number: '080 07 59 63',
  market: 'BE',
  language: 'fr'
}, {
  number: '900 99 33 52',
  market: 'ES',
  language: 'es'
}, {
  number: '0800 180 65 33',
  market: 'DE',
  language: 'de'
}, {
  number: '800 87 07 99',
  market: 'IT',
  language: 'it'
}, {
  number: '800 25 460',
  market: 'LU',
  language: 'fr'
}, {
  number: '0800 02 28 216',
  market: 'NL',
  language: 'nl'
}, {
  number: '0800 29 52 80',
  market: 'AT',
  language: 'de'
}, {
  number: '800 83 31 73',
  market: 'PT',
  language: 'pt'
}, {
  number: '0800 83 66 05',
  market: 'CH',
  language: 'de'
}, {
  number: '0800 83 66 05',
  market: 'CH',
  language: 'it'
}, {
  number: '0800 83 66 05',
  market: 'CH',
  language: 'fr'
}, {
  number: '0808 234 21 72',
  market: 'UK',
  language: 'en'
}];
var DEFAULT_LOCALE = {
  market: 'FR',
  currency: 'EUR',
  symbol: '€',
  language: 'fr',
  iso: 'fr-FR',
  name: 'Français'
};
export { LOCALES, DEFAULT_LOCALE, SERVICE_NUMBER };